import axios from 'axios';

const api = axios.create({
  baseURL: '/api/',
  withCredentials: true
});

// Response-Interceptor: 5xx-Fehler loggen für Debugging
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status >= 500) {
      console.error(
        `[API] ${error.response.status} ${error.config?.method?.toUpperCase()} ${error.config?.url}`,
        error.response.data
      );
    }
    return Promise.reject(error);
  }
);

export default api;